var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center pa-8",style:(("min-height: " + _vm.minHeight + "px; display: flex; align-items: center; justify-content: center;"))},[_c('p',[_vm._v(_vm._s(_vm.$t('message.nenhum_registro', 1)))])])}
var staticRenderFns = []

export { render, staticRenderFns }